import { BathroomHealthStatus, BedroomsHealthStatus, CeilingStatus, DoorStatus, FloorStatus, MoistStatus, ToiletHealthStatus, UnitInspectionInfoDTO, WallStatus, WindowStatus, WindowTerraceSafetyStatus } from "shared/types/unit-inspection";


export const calculateUnitVisualInspectionDotValues = (unitInspectionInfo: UnitInspectionInfoDTO) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (Number(unitInspectionInfo.ceilingHeight) >= 250) {
        dotValues.green.count++;
        dotValues.green.labels.push("Alle plafonds voldoende hoog (>= 250 cm)");
    } else if (Number(unitInspectionInfo.ceilingHeight) >= 220 && Number(unitInspectionInfo.ceilingHeight) < 250) {
        dotValues.green.count++;
        dotValues.green.labels.push("Alle plafonds tussen 220 en 250 cm");;
    } else if (unitInspectionInfo.ceilingHeight && Number(unitInspectionInfo.ceilingHeight) && Number(unitInspectionInfo.ceilingHeight) < 220) {
        dotValues.red.count++;
        dotValues.red.labels.push("Plafonds niet voldoende hoog (< 220cm)");;
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Plafondhoogtes te inspecteren");
    }

    if (unitInspectionInfo.ceilingStatus === CeilingStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Goede afwerking, geen barsten of gaten in plafonds");
    } else if (unitInspectionInfo.floorStatus === FloorStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Zichtbare slijtage, barsten of gaten in plafonds");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Plafonds te inspecteren");
    }

    if (unitInspectionInfo.floorStatus === FloorStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Goede afwerking, geen barsten of gaten in vloeren");
    } else if(unitInspectionInfo.floorStatus === FloorStatus.PARTIALY_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Kleine slijtage zoals scheurtjes, maar niets ernstigs");
    } else if (unitInspectionInfo.floorStatus === FloorStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Zichtbare slijtage, barsten of gaten in vloeren");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Vloeren te inspecteren");
    }

    if (unitInspectionInfo.wallStatus === WallStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Goede afwerking van muren, geen barsten of gaten");
    } else if (unitInspectionInfo.wallStatus === WallStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Zichtbare slijtage, barsten of gaten in muren");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Muren te inspecteren");
    }

    if (unitInspectionInfo.moistStatus === MoistStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen schimmel of vochtproblemen vastgesteld");
    } else if (unitInspectionInfo.moistStatus === MoistStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Wel schimmel of vochtproblemen vastgesteld");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Te inspecteren op vocht en schimmels");
    }

    if ([WindowTerraceSafetyStatus.OK, WindowTerraceSafetyStatus.NOT_REQUIRED].includes(unitInspectionInfo.windowTerraceSafetyStatus)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Veilig terras of borstwering voorzien bij lage ramen");
    } else if (unitInspectionInfo.windowTerraceSafetyStatus === WindowTerraceSafetyStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Onveilige situatie bij terras en/of lage ramen");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Balkon en ramen te inspecteren op borstwering");
    }


    if (unitInspectionInfo.doorStatus === DoorStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Deuren water- en winddicht, alle deuren kunnen open en sluiten goed af met de sleutel, geen zichtbare schade");
    } else if (unitInspectionInfo.doorStatus === DoorStatus.PARTIAL_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("De meeste deuren zijn ok, maar enkele deuren vertonen gebreken");
    } else if (unitInspectionInfo.doorStatus === DoorStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Overwegend alle deuren vertonen gebreken");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Deuren te inspecteren");
    }


    if (unitInspectionInfo.windowStatus === WindowStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Water- en winddicht, alle ramen kunnen open en sluiten goed af, geen zichtbare schade");
    } else if (unitInspectionInfo.windowStatus === WindowStatus.PARTIAL_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("De meeste ramen zijn ok, maar enkele ramen vertonen gebreken");
    } else if (unitInspectionInfo.windowStatus === WindowStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Overwegend alle ramen vertonen gebreken");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Ramen te inspecteren");
    }

    if((unitInspectionInfo.numBathrooms || unitInspectionInfo.numBathrooms === 0) && (unitInspectionInfo.numToilets || unitInspectionInfo.numToilets === 0) && (unitInspectionInfo.numBedrooms || unitInspectionInfo.numBedrooms === 0)) {
        dotValues.green.count++;
        dotValues.green.labels.push("# belangrijke ruimtes ingevuld");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("# belangrijke ruimtes te inspecteren");
    }

    if (unitInspectionInfo.bedroomsHealthStatus === BedroomsHealthStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Natuurlijk licht en ventilatie mogelijk in alle slaapkamers");
    } else if (unitInspectionInfo.bedroomsHealthStatus === BedroomsHealthStatus.PARTIAL_OK_LIGHT) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("In alle slaapkamers is licht aanwezig, maar niet overal is ventilatie mogelijk");
    } else if (unitInspectionInfo.bedroomsHealthStatus === BedroomsHealthStatus.PARTIAL_OK_VENTILATION) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("In alle slaapkamers is ventilatie mogelijk, maar geen natuurlijk licht in alle slaapkamers");
    } else if (unitInspectionInfo.bedroomsHealthStatus === BedroomsHealthStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Geen licht en geen ventilatie mogelijk in diverse slaapkamers");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Slaapkamers te inspecteren op ventilatie en natuurlijk licht");
    }

    if (unitInspectionInfo.toiletHealthStatus === ToiletHealthStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Ventilatie mogelijk in toilet");
    } else if (unitInspectionInfo.toiletHealthStatus === ToiletHealthStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Geen ventilatie mogelijk in toilet");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Toilet te inspecteren op ventilatie");
    }


    if (unitInspectionInfo.bathroomHealthStatus === BathroomHealthStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Natuurlijk licht en ventilatie mogelijk in badkamer");
    } else if (unitInspectionInfo.bathroomHealthStatus === BathroomHealthStatus.PARTIAL_OK_LIGHT) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Natuurlijk licht aanwezig in badkamer, maar geen ventilatie mogelijk");
    } else if (unitInspectionInfo.bathroomHealthStatus === BathroomHealthStatus.PARTIAL_OK_VENTILATION) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Ventilatie mogelijk, maar geen natuurlijk licht in badkamer");
    } else if (unitInspectionInfo.bathroomHealthStatus === BathroomHealthStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Geen natuurlijk licht en geen ventilatie mogelijk in badkamer");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Badkamer te inspecteren op ventilatie en natuurlijk licht");
    }

    return dotValues;
};
